import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var propTypes = {
  /**
  * The visual style of the PromoBar
  */
  skin: PropTypes.oneOf(['standard', 'holiday', 'holiday-green', 'holiday-beige', 'discount', 'inverse'])
};
var PromoBar = createComponent({
  displayName: 'PromoBar',
  root: 'div',
  propTypes: propTypes,
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.promoBar,
  propConfig: {
    classNames: function classNames(props) {
      var classesSet = new Set(['swan-promo-bar']);
      if (props.skin && props.skin !== 'standard') classesSet.add("swan-promo-bar-skin-".concat(props.skin));
      return classesSet;
    }
  }
});
PromoBar.defaultProps = {
  skin: 'standard'
};
export { PromoBar };